export interface NavigationEntity {
  id: number;
  name: string;
  archived?: boolean;
}

export interface NavigationArticle extends NavigationEntity {
  itemCode: string;
  basedOnId?: number | null;
  basedOnArticleNumber?: string | null;
  hasMatrix: boolean;
  isVdc: boolean;
  collectionItem: boolean;
  syncedVariantId?: number | null;
}

export interface NavigationVariant {
  id: number;
  name: string;
  archived: boolean;
  isMain: boolean;
  isProductDevelopment: boolean;
  optionLinkId: number | null;
}

interface BaseNavigationContext {
  customer: NavigationEntity;
}

export interface CustomerNavigationContext extends BaseNavigationContext {
  type: 'customer';
}

export interface ConceptNavigationContext extends BaseNavigationContext {
  type: 'concept';
  concept: NavigationEntity;
}

export interface ArticleNavigationContext extends BaseNavigationContext {
  type: 'article';
  article: NavigationArticle;
  betaFeatures: boolean;
  concept?: NavigationEntity;
  currentVariantId: number | null;
  variants: NavigationVariant[];
}

export type NavigationContext =
  | CustomerNavigationContext
  | ConceptNavigationContext
  | ArticleNavigationContext;

export interface NavigationStoreSnapshot {
  activeState: string;
  context: NavigationContext | null;
}

let snapshot: NavigationStoreSnapshot = {
  activeState: '',
  context: null,
};

const listeners = new Set<() => void>();

function emitChange() {
  listeners.forEach((listener) => listener());
}

export const navigationStore = {
  getSnapshot: () => snapshot,
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  setActiveState: (activeState: string) => {
    if (snapshot.activeState === activeState) {
      return;
    }

    snapshot = { ...snapshot, activeState };
    emitChange();
  },
  setContext: (context: NavigationContext | null) => {
    snapshot = { ...snapshot, context };
    emitChange();
  },
};
